import { isAfter } from 'date-fns';

export const getAvailableUnits = ({ property, moveInInformation, availableUnits }) => {
    const floorPlan = property?.floor_plans.find(fp => fp.id === moveInInformation.selectedFloorPlan);

    const options = availableUnits.filter(u => {
            if (u.floor_plan !== floorPlan?.name) return false;
            if (u.status === 'available') return true;
            const moveInDate = new Date(moveInInformation.moveInDate);
            const vacateDate = new Date(u.vacate_date);
            return (isAfter(moveInDate, vacateDate) && u.status === 'on_notice');
        })
        .map((unit) => {
            return { display: `${unit.number} - $${unit.market_rent}`, id: unit.number };
        });

    return options.slice(0, 2);

}
